import React, { FC } from 'react';
import { SectionBreadcrumbs } from '../../common/SectionBreadcrumbs';
import { ClassifierMappingBreadcrumbsProps } from './ClassifierMappingBreadcrumbs.types';
import { CLASSIFIER_MAPPING_ROUTES } from './ClassifierMappings';

export const ClassifierMappingBreadcrumbs: FC<
  ClassifierMappingBreadcrumbsProps
> = (props) => (
  <SectionBreadcrumbs {...props} routes={CLASSIFIER_MAPPING_ROUTES} />
);
